<app-new-dashboard-header tab="home" [workplace]="workplace"></app-new-dashboard-header>
<div class="govuk-width-container govuk-!-margin-top-7">
  <app-alert></app-alert>
  <app-summary-section
    [canViewListOfWorkers]="canViewListOfWorkers"
    [workplace]="workplace"
    [workers]="workers"
    [workerCount]="workerCount"
    [workersCreatedDate]="workersCreatedDate"
    [trainingCounts]="trainingCounts"
    [workersNotCompleted]="workersNotCompleted"
    [(navigateToTab)]="navigateToTab"
    [canViewEstablishment]="canViewEstablishment"
    [canEditEstablishment]="canEditEstablishment"
    [canEditWorker]="canEditWorker"
    [noOfWorkersWhoRequireInternationalRecruitment]="noOfWorkersWhoRequireInternationalRecruitment"
    [numberOfStaffIncludedInCWPRoleCategories]="numberOfStaffIncludedInCWPRoleCategories"
    [noOfWorkersWithDelegatedHealthcareUnanswered]="noOfWorkersWithDelegatedHealthcareUnanswered"
    [showCheckCqcDetails]="showCheckCqcDetails"
  ></app-summary-section>
</div>
<div class="govuk-width-container govuk-!-margin-top-7" data-cy="cards-and-links">
  <div class="govuk-grid-row">
    <div class="govuk-grid-column-two-thirds">
      <div class="govuk-grid-row">
        @if (canViewReports) {
        <div class="govuk-grid-column-one-half govuk-!-padding-right-1">
          <app-card [image]="'/assets/images/access-funding.svg'" title="Access funding">
            <a class="govuk-link govuk-link--no-visited-state asc-card-link" routerLink="/funding" href="#">
              LDSS funding {{ fundingYear }}</a
            >
            <p class="govuk-!-margin-0 asc-card-description">
              Check your eligibility to claim funding for staff training.
            </p></app-card
          >
        </div>
        }

        <div class="govuk-grid-column-one-half govuk-!-padding-left-1">
          <app-card [image]="'/assets/images/benchmarks.svg'" title="Benchmarks">
            <a
              (click)="navigateToTab($event, 'benchmarks')"
              class="govuk-link govuk-link--no-visited-state asc-card-link"
              href="#"
            >
              @if (bigThreeServices && hasBenchmarkComparisonData) { Compare your workplace<span class="asc-card-break"
                ><br /></span
              >on staff pay and retention } @else { See how you compare against other workplaces }
            </a>
            <p class="govuk-!-margin-0 asc-card-description">
              {{ benchmarksMessage }}
            </p>
          </app-card>
        </div>
      </div>
    </div>
    <div class="govuk-grid-column-one-third">
      <app-new-article-list data-testid="article-list"></app-new-article-list>
      <app-other-links
        [canBulkUpload]="canBulkUpload"
        [canViewReports]="canViewReports"
        [isParentSubsidiaryView]="false"
        [canBecomeAParent]="canBecomeAParent"
        [canLinkToParent]="canLinkToParent"
        [isParent]="workplace.isParent"
        [linkToParentRequestedStatus]="linkToParentRequestedStatus"
        [parentStatusRequested]="parentStatusRequested"
        [canViewChangeDataOwner]="canViewChangeDataOwner"
        [isOwnershipRequested]="isOwnershipRequested"
        [canViewDataPermissionsLink]="canViewDataPermissionsLink"
        [canRemoveParentAssociation]="canRemoveParentAssociation"
        [canViewChangeDataOwner]="canViewChangeDataOwner"
        (ownershipChangeMessageEvent)="ownershipChangeMessage($event)"
        (cancelChangeDataOwnerRequestEvent)="cancelChangeDataOwnerRequest($event)"
      ></app-other-links>
    </div>
  </div>
</div>
